(function () {
    'use strict';

    a3_cabin_reports.factory('JumpseatRequestsFactory', JumpseatRequestsFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name JumpseatRequestsFactory
     * @description
     *   Service for Jumpseat Requests data management
     * @ngInject
     */
    function JumpseatRequestsFactory($http, apiUrl) {

        var jumpseatApiURL = apiUrl + '/JumpseatRequests';
        var jumpseatInfoAction = jumpseatApiURL + '/GetJumpseatInfo';
        var cancelAction = jumpseatApiURL + '/CancelRequest';
        var submitRequestAction = jumpseatApiURL + '/SubmitRequest';
        
        var service = {
            getJumpseatInfo: getJumpseatInfo,
            cancelRequest: cancelRequest,
            submitRequest: submitRequest
        }; 

        /**
         * Get jumpseat information.
         * For now this returns mock data. Replace with jumpseatInfoAction when API is ready.
         * @param {function} callback an on success callback function
         * @param {function} errorCallback an on error callback function
         */
        function getJumpseatInfo(callback, errorCallback) {
            // Real API call (without mock data):
            return $http.post(jumpseatInfoAction, { 'Content-Type': 'application/json' })
                .then(function (responseData) {
                    callback(responseData.data);
                })
                .catch(errorCallback);

                // Mock data call:
            // return $http.get('views/JumpseatRequests/jumpseatInfo.mock.json', { 'Content-Type': 'application/json' })
            //     .then(function (responseData) {
            //         var payload = responseData.data;
            //         callback({
            //             success: true,
            //             data: {
            //                 data: payload
            //             },
            //             errorMessage: null
            //         });
            //     })
            //     .catch(errorCallback); 
        }

        /**
         * Cancel an existing jumpseat request.
         * @param {number} requestId request identifier
         * @param {function} callback an on success callback function
         * @param {function} errorCallback an on error callback function
         */
        function cancelRequest(requestId, callback, errorCallback) {
            return $http.post(cancelAction, requestId, { 'Content-Type': 'application/json' })
                .then(function (responseData) {
                    callback(responseData.data);
                })
                .catch(errorCallback);
        }

        /**
         * Submit a new jumpseat request.
         * @param {object} requestData jumpseat request payload
         * @param {function} callback an on success callback function
         * @param {function} errorCallback an on error callback function
         */
        function submitRequest(requestData, callback, errorCallback) {
            return $http.post(submitRequestAction, requestData, { 'Content-Type': 'application/json' })
                .then(function (responseData) {
                    callback(responseData.data);
                })
                .catch(errorCallback);
        }

        return service;
    }
})();
